/* eslint-disable no-unused-vars */
import React from 'react';

import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import './index.less';
import './index.en.less';
import Section0 from './section0';
import Section1 from './section1';
import Section2 from './section2';
interface ITopic1400Props {
  settings: any;
}

const Ptm: React.FunctionComponent<ITopic1400Props> = ({ settings }) => (
  <TopicContainer className="ptm">
    <TopicItem id="1">
      <Section0 settings={settings} />
    </TopicItem>
    <TopicItem id="2" className="topic-item ptm_2">
      <Section1 settings={settings} />
    </TopicItem>
    <TopicItem id="3" className="topic-item ptm_3">
      <Section2 settings={settings} />
    </TopicItem>
  </TopicContainer>
);

export default Ptm;
